import { ApiClientContext } from "context/ApiClientProvider";

import { useContext, useMemo } from "react";

export type ApiClientClass<T> = new (...args: unknown[]) => T;

export function useApi<T>(Client: ApiClientClass<T>) {
  const axiosInstance = useContext(ApiClientContext);

  const client = new Client(axiosInstance);

  return client;
}

export function useApiInstance() {
  return useContext(ApiClientContext);
}
